// Caches how many IT components an organization has, keyed per organization
// (unlike the user-level organizations count) so the /it_components skeleton
// renders the right number of cards immediately on repeat visits instead of
// a generic placeholder. Written after every successful unfiltered fetch;
// read synchronously at component setup time.
//
// Thin, page-specific wrapper around the generic cache — see
// composables/useSkeletonCountCache.js and docs/skeleton_count_caching.md.
import { getCachedSkeletonCount, setCachedSkeletonCount } from './useSkeletonCountCache'

const DEFAULT_COUNT = 8

export function getCachedItComponentsCount(organizationId) {
  return getCachedSkeletonCount(`it_components:${organizationId}`, DEFAULT_COUNT)
}

export function setCachedItComponentsCount(organizationId, count) {
  setCachedSkeletonCount(`it_components:${organizationId}`, count)
}
